import styled, { css } from 'styled-components';
import { deviceWidths } from '../../../variables/widths.js';

var Body = styled.div.withConfig({
  displayName: "body__Body",
  componentId: "sc-83l51s-0"
})(["box-sizing:border-box;overflow-y:auto;@media (max-width:", "){flex-grow:1;height:0;max-width:100vw;}", ""], deviceWidths.tabletMax, function (props) {
  return props.defaultPadding && css(["width:100%;padding:32px 16px;@media (min-width:", "){padding:40px 32px;}"], deviceWidths.tablet);
});

export { Body };
//# sourceMappingURL=body.js.map
